import React, { useEffect, useContext, useState } from "react";
import axios from "axios";
import { PatentContext } from "../context/PatentContextProvider";
import { Outlet, Navigate, useLocation } from "react-router-dom";

const ProtectedRoute = ({ allowedRoles }) => {
  const { userData, setUserData } = useContext(PatentContext);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("token");
  const location = useLocation();

  useEffect(() => {
    const checkUser = async () => {
      if (!token) {
        setLoading(false);
        return;
      }

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_PATH}/me`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.status === 200) {
          setUserData(response.data);
          localStorage.setItem("userId", response.data._id);
        }
      } catch (error) {
        console.error("User authentication failed:", error);
      } finally {
        setLoading(false);
      }
    };

    checkUser();
  }, [token, setUserData]);

  if (loading) return <div>Loading...</div>;

  // 🔹 No token → go login
  if (!token) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // 🔹 Role check
  if (allowedRoles && userData && !allowedRoles.includes(userData.role)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
